import React, { Component, Fragment } from "react";
import leftArrowImage from '../../assets/images/left-arrow.png'

import {
  SystemServices,
  UtilityService,
  CountryServices,
  SampleServices,
  PermissionServices,
  DevelopmentServices
} from "../../services";
import AlertContainer from "react-alert";
import Async from "react-select";
import Field from "../../components/Common/Field/Field";
import Button from '../../components/Buttons/Button'

class AddCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      systemModule: [],
      editData: {},
      objectId: "",
      heading: "",
      categoryContentHeading: "",
      categoryValue: "",
      country: null,
      ratio: "",
      needle: "",
      looper: "",
      overLock: "",
      trimThread: "",
      sheeringNeedle: "",
      operationWholeData: "",
      operationId: "",
      operationName: "",
      trimRef: "",
      currencyValue: "",
      price: "",
      number: '',
      portOfPickup: {},
      unitsOption: [],
      typeMultiple: [{
        width: null,
        price: null
      }],
      status: false,
    };
    // this.countriesList = this.countriesList.bind(this);
    this.submitValue = this.submitValue.bind(this);
  }

  alertOptions = {
    offset: 65,
    position: "top left",
    theme: "dark",
    time: 1000,
    transition: "scale"
  };
  
  componentWillMount() {

    let fullValue = [this.props.location.pathname.slice(1), ...this.props.location.search.split("?").slice(1)];
    this.setState({
      systemModule: [...fullValue]
    });
    this.setState({ categoryId: fullValue[1] });
    this.setState({
      categoryType: fullValue[0]
    });


    if (fullValue[0] == "add") {
      this.setState({
        categoryContentHeading: fullValue[3],
        heading: fullValue[2] === 'GREIGE&DENIM' ? 'GREIGE/DENIM' : fullValue[2]
      });
    } else {
      this.setState({
        categoryContentHeading: fullValue[4],
        objectId: fullValue[1],
        heading: fullValue[3] === 'GREIGE&DENIM' ? 'GREIGE/DENIM' : fullValue[3]
      });
    }

    if ((fullValue[0] === 'add' && fullValue[3] === 'TRIM_CATEGORY') ||
      (fullValue[0] === 'edit' && fullValue[4] === 'TRIM_CATEGORY')) {
      //TRIMCATEGORY By
      let unitsOption = [];
      DevelopmentServices.getTrimSysUnits().then(data => {
        data.data.map((unit) => {
          unitsOption.push({
            label: unit.name,
            value: unit._id
          })
          this.setState({ unitsOption })
        })
      }).catch((err) => { return err });

    }

    if ((fullValue[0] === 'add' && fullValue[3] === 'ASSIGNED_TO') || (fullValue[0] === 'edit' && fullValue[4] === 'ASSIGNED_TO')) {
      //actioned By
      let actionedByOption = [];
      PermissionServices.searchEmploye("").then(async response => {
        if (response.status === 200) {
          actionedByOption = await response.text.data
          this.setState({ actionedByOption, isLoading: true });
        }
      });
    }


    if ((fullValue[3] === 'CITY' && fullValue[0] === 'add') || (fullValue[4] === 'CITY' && (fullValue[0] === 'edit' || fullValue[0] === 'view'))) {
      //countriesList
      let countriesList = [];
      SystemServices.getCountryList().then(async response => {
        if (response.status === 200) {
          countriesList = await response.text.data
          this.setState({ countriesList, isLoading: true });
        }
      });
    }


    SystemServices.getDataById(fullValue[1], fullValue[2])
      .then(response => {
        if (response.message === "system data") {
          this.setState({ categoryValue: response.data.name });
          if (response.data.subHeading === "CURRENCY") {
            this.setState({
              currency: response.data.currency,
              currencyValue: response.data.currencyValue
            });
          }
          if (response.data.subHeading === "PORTOFPICKUP") {
            let portOfPickup = {
              portofpickup: response.data.name,
              freightCostAbove500: response.data.freightCostAbove500,
              freightCostBelow500: response.data.freightCostBelow500,
              seaFreightCost: response.data.seaFreightCost
            };
            this.setState({ portOfPickup });

          }
          if (response.data.subHeading === "ASSIGNEDTO") {
            let assignedToObj = {
              label: `${response.data.assignedTo.firstName} ${response.data.assignedTo.lastName}`,
              value: response.data.assignedTo._id
            };
            this.setState({ assignedToObj });
          }
          if (response.data.subHeading === 'TRIMCATEGORY') {
            this.setState({
              trimRef: response.data.referNo,
              units: response.data.unit,
              status: response.data.status
            })
          }
          if (response.data.subHeading === 'CITY') {
            this.setState({
              country: response.data.country,
            })
          }
          if (response.data.subHeading == 'BACKINGTYPE') {
            this.setState({
              typeMultiple: response.data.typeMultiple,
            })
          }
          if (response.data.subHeading == 'MACHINE') {
            this.setState({
              needleCode: response.data.needleCode,
              factor: response.data.factor,
              needle: response.data.needle,
              looper: response.data.looper,
              overLock: response.data.overLock,
              trimThread: response.data.trimThread,
              sheeringNeedle: response.data.sheeringNeedle
            })
          }
          if (response.data.subHeading == 'WASHTYPE' || response.data.subHeading == 'EMBFORM') {
            this.setState({
              price: response.data.price
            })
          }

          if (response.data.subHeading == 'TAILORSNAME') {
            this.setState({
              number: response.data.number
            })
          }
        }
      })
      .catch(error => {
        this.props.getalertMessage('error', error.toString());
      });

    // this.countriesList();
  }

  //Submitting value add and edit happens
  submitValue(e) {
    if (
      this.state.categoryContentHeading === "MACHINE" &&
      this.state.categoryType === "add"
    ) {

      SystemServices.addCategoryForMachine(
        this.state.categoryValue,
        this.state.needleCode,
        this.state.factor,
        this.state.needle,
        this.state.looper,
        this.state.heading,
        this.state.overLock,
        this.state.trimThread,
        this.state.sheeringNeedle
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            UtilityService.successMsg(this.msg);

            this.setState({
              categoryValue: "",
              needleCode: "",
              factor: "",
              needle: "",
              looper: "",
              overLock: "",
              trimThread: "",
              sheeringNeedle: ""
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "MACHINE" &&
      this.state.categoryType === "edit"
    ) {
      SystemServices.editCategoryForMachine(
        this.state.categoryId,
        this.state.categoryValue,
        this.state.needleCode,
        this.state.factor,
        this.state.needle,
        this.state.looper,
        this.state.heading,
        this.state.overLock,
        this.state.trimThread,
        this.state.sheeringNeedle
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "ADDRESS" &&
      this.state.categoryType === "add"
    ) {
      SystemServices.addCategoryForAddress(
        this.state.categoryValue,
        this.state.cityName,
        this.state.address,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            this.msg.show("Successfully Added", {
              time: 2000,
              type: "success"
            });

            this.setState({
              categoryValue: "",
              address: "",
              cityName: ""
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "ADDRESS" &&
      this.state.categoryType === "edit"
    ) {
      SystemServices.editCategoryForAddress(
        this.state.categoryContentHeading.split("_").join(""),
        this.state.categoryInfo,
        this.state.categoryId,
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "CITY" &&
      this.state.categoryType === "add"
    ) {
      SystemServices.addCategoryForCity(
        this.state.categoryValue,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.country,
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            this.msg.show("Successfully Added", {
              time: 2000,
              type: "success"
            });
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "CITY" &&
      this.state.categoryType === "edit"
    ) {
      SystemServices.editCategoryForCity(
        this.state.categoryValue,
        this.state.country,
        this.state.categoryId
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "TRIM_CATEGORY" &&
      this.state.categoryType === "add"
    ) {
      SystemServices.addCategoryForTrimCat(
        this.state.categoryValue,
        this.state.trimRef,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.units,
        this.state.status,
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            this.msg.show("Successfully Added", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }

    // done by viswa
    else if (
      this.state.categoryContentHeading === "TRIM_COLOR" &&
      this.state.categoryType === "add"
    ) {
      SystemServices.addCategoryToParentTrim(
        this.state.categoryValue,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            this.msg.show("Successfully Added", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }

    //viswa
    else if (
      this.state.categoryContentHeading === "TRIM_CATEGORY" &&
      this.state.categoryType === "edit"
    ) {
      SystemServices.editCategoryForTrimCat(
        this.state.categoryValue,
        this.state.trimRef,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.units,
        this.state.status,
        this.state.categoryId,
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "CURRENCY" &&
      this.state.categoryType === "add"
    ) {
      SystemServices.addCategoryForCurrency(
        this.state.categoryValue,
        this.state.currencyValue,
        this.state.currency,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            this.msg.show("Successfully Added", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "CURRENCY" &&
      this.state.categoryType === "edit"
    ) {
      SystemServices.editCategoryForCurrency(
        this.state.categoryValue,
        this.state.currencyValue,
        this.state.currency,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.heading,
        this.state.categoryId
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      (this.state.categoryContentHeading === "INITIAL" ||
        this.state.categoryContentHeading === "PRODUCTION") &&
      (this.state.categoryType === "edit" || this.state.categoryType === "add")
    ) {
      SystemServices.addSampleRequestType(
        this.state.categoryContentHeading.split("_").join(""),
        this.state.cadDoneBy.value,
        this.state.heading
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            this.msg.show("Successfully Added", {
              time: 2000,
              type: "success"
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else if (
      this.state.categoryContentHeading === "PORT_OF_PICK_UP" &&
      this.state.categoryType === "add"
    ) {
      SystemServices.addCategoryForPortofpickup(
        this.state.portOfPickup,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.systemModule[2].toUpperCase(),
        this.state.systemModule[1].toUpperCase()
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            UtilityService.successMsg(this.msg);
            this.setState({ portOfPickup: {} });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }

    else if (
      this.state.categoryContentHeading === "PORT_OF_PICK_UP" &&
      this.state.categoryType === "edit"
    ) {
      SystemServices.editCategoryForPortofpickup(
        this.state.portOfPickup,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.heading,
        this.state.categoryId
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            UtilityService.successMsg(this.msg);
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
    else if (this.state.categoryContentHeading === "ASSIGNED_TO" && this.state.categoryType === "add") {
      SystemServices.addCategory(
        this.state.assignedTo,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.systemModule[2].toUpperCase().replace('&', '/'),
        this.state.systemModule[1].toUpperCase()
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            UtilityService.successMsg(this.msg);
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
    else if (this.state.categoryContentHeading === "ASSIGNED_TO" && this.state.categoryType === "edit") {
      SystemServices.editCategory(
        this.state.assignedTo,
        this.state.categoryId,
        this.state.systemModule[2],
        this.state.categoryContentHeading.split("_").join("")
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
    else if (this.state.categoryContentHeading === "BACKING_TYPE" && this.state.categoryType === "add") {
      SystemServices.addCategoryForBackingType(
        this.state.categoryValue,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.systemModule[2].toUpperCase().replace('&', '/'),
        this.state.typeMultiple
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            UtilityService.successMsg(this.msg);
            this.setState({
              categoryValue: "", typeMultiple: [{
                width: null,
                price: null
              }]
            });

          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
    else if (this.state.categoryContentHeading === "BACKING_TYPE" && this.state.categoryType === "edit") {
      SystemServices.editCategoryForBackingType(
        this.state.categoryValue,
        this.state.categoryId,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.systemModule[2].toUpperCase().replace('&', '/'),
        this.state.typeMultiple
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
            this.setState({
              categoryValue: "", typeMultiple: [{
                width: null,
                price: null
              }]
            });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
    else if (this.state.categoryType === "add") {
      SystemServices.addCategory(
        this.state.categoryValue,
        this.state.categoryContentHeading.split("_").join(""),
        this.state.systemModule[2] == "SMV&THREADCONSUMPTION" ? this.state.systemModule[2] :
          this.state.systemModule[2].toUpperCase().replace('&', '/'),
        this.state.systemModule[1].toUpperCase(),
        this.state.price, null, null, null,
        this.state.number
      )
        .then(response => {
          if (response.message === "Successfully Added") {
            UtilityService.successMsg(this.msg);
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
    else if (this.state.categoryType == "edit" && this.state.heading == 'CAD') {
      SystemServices.editCategoryForCad(
        this.state.categoryValue,
        this.state.categoryId,
        this.state.systemModule[2]
      ).then(response => {
        if (response.message === "Successfully updated") {
          this.msg.show("Successfully Updated", {
            time: 2000,
            type: "success"
          });
          this.setState({ categoryValue: "" });
        } else if (response.message === "Entry already exists") {
          UtilityService.warningMsg(this.msg);
        }
      })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    } else {
      SystemServices.editCategory(
        this.state.categoryValue,
        this.state.categoryId,
        this.state.systemModule[2],
        null,
        this.state.price, this.state.number
      )
        .then(response => {
          if (response.message === "Successfully updated") {
            this.msg.show("Successfully Updated", {
              time: 2000,
              type: "success"
            });
            this.setState({ categoryValue: "" });
          } else if (response.message === "Entry already exists") {
            UtilityService.warningMsg(this.msg);
          }
        })
        .catch(error => {
          this.props.getalertMessage('error', error.toString());
        });
    }
  }

  addSubCategoryCount() {
    let { subCategoryQty } = this.state;
    subCategoryQty.push({ name: "" });
    this.setState({ subCategoryQty });
  }

  changeSubCategory(e, index) {
    let { subCategoryQty } = this.state;
    subCategoryQty[index][e.target.name] = e.target.value;
    this.setState({ subCategoryQty }, function () { });
  }

  removeCategoryCount(e, index) {
    let { subCategoryQty } = this.state;
    subCategoryQty.splice(index, 1);
    this.setState({ subCategoryQty });
  }

  changeAddress(e) {
    let { categoryInfo } = this.state;
    categoryInfo.categoryName = e.target.value;
    this.setState({ categoryInfo });
  }

  changeCountry = categoryValue => {
    this.setState({ categoryValue });
  };
  getDoneBy = value => {
    SampleServices.getDoneBy(value)
      .then(response => {
        if (response.message === "list displayed") {
          let jsonData = [];
          response.data.map((value, index) => {
            let empObj = {};
            empObj.label = value.firstName;
            empObj.value = value._id;
            jsonData.push(empObj);
          });
          this.setState({ doneBy: jsonData });
        }
      })
      .catch(error => {
        this.props.getalertMessage('error', error.toString());
      });
  };

  changeCADDoneBy = cadDoneBy => {
    this.setState({ cadDoneBy });
  };

  changeAsync = currency => {
    this.setState({ categoryValue: currency.label, currency });
  };

  updatePortOfPickup = (name, value) => {
    let portOfPickup = { ...this.state.portOfPickup };
    portOfPickup[name] = value;
    this.setState({ portOfPickup });
  };

  getAssignedTo = (data) => {

    if (data !== null) {
      this.setState({
        assignedTo: data.value,
        assignedToObj: data
      })
    } else {
      this.setState({
        assignedToObj: null
      })
    }
  }

  updateTypeMultiple = (name, value, index) => {
    let typeMultiple = [...this.state.typeMultiple]
    typeMultiple[index][name] = value
    this.setState({
      typeMultiple
    })
  }

  addTypeMultiple = () => {
    // alert("add" )
    let typeMultiple = [...this.state.typeMultiple]
    typeMultiple.push({
      width: null,
      price: null
    })
    this.setState({
      typeMultiple
    })
  }

  removeMultiple = (index) => {
    let typeMultiple = [...this.state.typeMultiple]
    typeMultiple.splice(index, 1)
    this.setState({
      typeMultiple
    })
  }

  render() {
    const { portOfPickup } = this.state;

    return (
      <Fragment>
        <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
        <div class="right-section">
          <div class="row nopadding bg-white full-width">
            <div class="col-md-12 px-0 py-2 position-top-stick">
              <div className="col-md-4 nopadding text-left">
                <span className="p-2 cursor-hover" onClick={(e) => this.props.history.goBack()} >
                  <img width={"20px"} src={leftArrowImage} />
                </span>
              </div>
              <div className="col-md-4 nopadding text-center">
                <h6>
                  {this.state.categoryType === "add"
                    ? "Add"
                    : this.state.categoryType === "edit"
                      ? "Edit"
                      : this.state.categoryType === "view"
                        ? "View"
                        : ""}{" "}
                  {this.state.categoryContentHeading !== undefined &&
                    this.state.categoryContentHeading.split("_").join(" ")}
                </h6>
              </div>
              <div className="col-md-4">
              </div>
            </div>
            <div class="col-md-12 nopadding">
              <div class="col-md-6 col-md-offset-3">
                <div class="col-md-12">
                  <div class="form-group">
                    {this.state.categoryContentHeading === "MACHINE" ? (


                      <Fragment>
                        <div class="col-md-12">
                          <div class="col-md-12 no-padding">
                            <div class="col-md-6">
                              <label>
                                {this.state.categoryContentHeading
                                  .split("_")
                                  .join(" ")}{" "}
                                Name (M/C)
                              </label>

                              <input
                                type="text"
                                class="form-control height-for-input-system"
                                placeholder=""
                                value={this.state.categoryValue}
                                onChange={e =>
                                  this.setState({
                                    categoryValue: e.target.value
                                  })
                                }
                                disabled={
                                  this.state.categoryType === "view"
                                    ? true
                                    : false
                                }
                              />
                            </div>

                            {/* <label>Ratio Name</label>

                              <input
                                type="text"
                                class="form-control height-for-input-system"
                                placeholder=""
                                value={this.state.ratio}
                                onChange={e =>
                                  this.setState({ ratio: e.target.value })
                                }
                                disabled={
                                  this.state.categoryType === "view"
                                    ? true
                                    : false
                                }
                              /> */}
                            <div class="col-md-6">
                              <label>Needle Code</label>

                              <input
                                type="text"
                                class="form-control height-for-input-system"
                                placeholder=""
                                value={this.state.needleCode}
                                onChange={e =>
                                  this.setState({ needleCode: e.target.value })
                                }
                                disabled={
                                  this.state.categoryType === "view"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </div>
                          <div class="col-md-12 no-padding">
                            <div class="col-md-4">
                              <label>Rating</label>

                              <input
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                class="form-control height-for-input-system"
                                placeholder=""
                                value={this.state.factor}
                                onChange={e =>
                                  this.setState({ factor: e.target.value })
                                }
                                disabled={
                                  this.state.categoryType === "view"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                            <div class="col-md-4">

                              <div className="form-group">
                                <label>Needle %</label>
                                <div className="d-flex">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.needle}
                                    onChange={e =>
                                      this.setState({ needle: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="p-1">%</span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">

                              <div className="form-group">
                                <label>Looper %</label>
                                <div className="d-flex">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.looper}
                                    onChange={e =>
                                      this.setState({ looper: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="p-1">%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12 no-padding">

                            <div class="col-md-4">

                              <div className="form-group">
                                <label>Over Lock % (O/L)</label>
                                <div className="d-flex">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.overLock}
                                    onChange={e =>
                                      this.setState({ overLock: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="p-1">%</span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <div className="form-group">
                                <label>Trim Thread Elastic % (TRD)</label>
                                <div className="d-flex">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.trimThread}
                                    onChange={e =>
                                      this.setState({ trimThread: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="p-1">%</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div className="form-group">
                                <label>Shirring Needle %</label>
                                <div className="d-flex">
                                  <input
                                    type="number"
                                    min="0"
                                    max="100"
                                    step="0.01"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.sheeringNeedle}
                                    onChange={e =>
                                      this.setState({ sheeringNeedle: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="p-1">%</span>
                                </div>
                              </div>
                            </div>
                            {/*
                              <label>OperationId</label>
                              {this.state.categoryType === "view" ? (
                                <input
                                  type="number"
                                  min="0"
                              max="100"
                                  class="form-control height-for-input-system"
                                  placeholder=""
                                  value={this.state.operationName}
                                  disabled
                                />
                              ) : (
                                <select
                                  class="form-control"
                                  onChange={e =>
                                    this.setState({
                                      operationId: e.target.value
                                    })
                                  }
                                  value={this.state.operationId}
                                >
                                  {this.state.operationWholeData !==
                                    undefined &&
                                    Array.isArray(
                                      this.state.operationWholeData
                                    ) &&
                                    this.state.operationWholeData.length > 0 &&
                                    this.state.operationWholeData.map(
                                      (data, index) => (
                                        <option value={data._id}>
                                          {data.name}
                                        </option>
                                      )
                                    )}
                                </select>
                              )} */}
                          </div>
                        </div>
                      </Fragment>
                    ) : this.state.categoryContentHeading === "CITY" ? (
                      <Fragment>
                        <label>Country Name</label>
                        <select
                          class="form-control height-for-input-system"
                          value={this.state.country}
                          onChange={e =>
                            this.setState(
                              { country: e.target.value },
                            )
                          }
                          disabled={this.state.categoryType === "view"}
                        >
                          <option value={""}>
                            {"select"}
                          </option>
                          {this.state.countriesList !== undefined &&
                            Array.isArray(this.state.countriesList) &&
                            this.state.countriesList.length > 0 &&
                            this.state.countriesList.map(
                              (country, index) => (
                                <option value={country.value}>
                                  {country.label}
                                </option>
                              )
                            )}
                        </select>

                        <label>
                          {this.state.categoryContentHeading
                            .split("_")
                            .join(" ")}{" "}
                          Name
                              </label>
                        <input
                          type="text"
                          class="form-control height-for-input-system"
                          value={
                            // this.state.categoryContentHeading ===
                            //   "CITY" ||
                            (this.state.categoryContentHeading ===
                              "ADDRESS" &&
                              this.state.categoryValue !== undefined)
                              ? this.state.categoryValue.categoryName
                              : this.state.categoryValue
                          }
                          onChange={e =>
                            this.setState({
                              categoryValue: e.target.value
                            })
                          }
                          disabled={
                            this.state.categoryType === "view"
                              ? true
                              : false
                          }
                        />
                      </Fragment>
                    ) : this.state.categoryContentHeading ===
                      "ADDRESS" ? (
                            <Fragment>
                              <label>Country Name</label>
                              {this.state.categoryType === "view" ? (
                                <input
                                  type="text"
                                  class="form-control height-for-input-system"
                                  placeholder=""
                                  value={
                                    this.state.categoryInfo !== undefined &&
                                    this.state.categoryInfo.country
                                  }
                                  disabled
                                />
                              ) : (
                                  <select
                                    class="form-control height-for-input-system"
                                    onChange={e =>
                                      this.setState({
                                        country: e.target.value
                                      })
                                    }
                                    value={this.state.categoryValue}
                                  >
                                    <option value="">Select</option>
                                    {this.state.uniqueCountries !== undefined &&
                                      Array.isArray(this.state.uniqueCountries) &&
                                      this.state.uniqueCountries.length > 0 &&
                                      this.state.uniqueCountries.map(
                                        (data, index) => (
                                          <option value={data._id}>
                                            {data.name}
                                          </option>
                                        )
                                      )}
                                  </select>
                                )}
                              <label>City Name</label>
                              {this.state.categoryType === "view" ? (
                                <input
                                  type="text"
                                  class="form-control height-for-input-system"
                                  placeholder=""
                                  value={
                                    this.state.categoryInfo !== undefined &&
                                    this.state.categoryInfo.categoryFull !==
                                    undefined &&
                                    this.state.categoryInfo.categoryFull
                                      .city !== undefined &&
                                    this.state.categoryInfo.categoryFull
                                      .city !== undefined &&
                                    this.state.categoryInfo.categoryFull.city
                                      .name
                                  }
                                  disabled
                                />
                              ) : (
                                  <select
                                    class="form-control height-for-input-system"
                                    onChange={e =>
                                      this.setState({ cityName: e.target.value })
                                    }
                                    value={this.state.cityName}
                                  >
                                    <option value="">Select</option>
                                    {this.state.wholeData !== undefined &&
                                      Array.isArray(this.state.wholeData) &&
                                      this.state.wholeData.length > 0 &&
                                      this.state.wholeData.map((data, index) => (
                                        <option value={data._id}>
                                          {data.name}
                                        </option>
                                      ))}
                                  </select>
                                )}
                              <label>
                                {this.state.categoryContentHeading
                                  .split("_")
                                  .join(" ")}{" "}
                                Name
                              </label>
                              {this.state.categoryType === "edit" ||
                                this.state.categoryType === "view" ? (
                                  <input
                                    type="text"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={
                                      this.state.categoryInfo !== undefined &&
                                      this.state.categoryInfo.categoryName
                                    }
                                    onChange={e => this.changeAddress(e)}
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.address}
                                    onChange={e =>
                                      this.setState({ address: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                )}
                            </Fragment>
                          ) : this.state.categoryContentHeading ===
                            "COUNTRY" ? (
                              <Fragment>
                                <label>
                                  {this.state.categoryContentHeading
                                    .split("_")
                                    .join(" ")}{" "}
                                  Name
                              </label>
                                <input
                                  type="text"
                                  value={this.state.categoryValue}
                                  class="form-control height-for-input-system"
                                  placeholder=""
                                  onChange={e =>
                                    this.setState({ categoryValue: e.target.value })
                                  }
                                  disabled={
                                    this.state.categoryType === "view"
                                      ? true
                                      : false
                                  }
                                />
                              </Fragment>
                            ) : this.state.categoryContentHeading ===
                              "TRIM_CATEGORY" ? (
                                <Fragment>
                                  <label>
                                    {this.state.categoryContentHeading
                                      .split("_")
                                      .join(" ")}{" "}
                                    Name
                              </label>

                                  <input
                                    type="text"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    value={this.state.categoryValue}
                                    onChange={e =>
                                      this.setState({
                                        categoryValue: e.target.value
                                      })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <label>Trim Ref</label>
                                  <input
                                    type="text"
                                    class="form-control height-for-input-system"
                                    placeholder=""
                                    name="trimRef"
                                    value={this.state.trimRef}
                                    onChange={e =>
                                      this.setState({ trimRef: e.target.value })
                                    }
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <label>Units</label>

                                  <Field
                                    className={"form-control height-for-input-system"}
                                    inputType={'select'}
                                    inputName={'units'}
                                    value={this.state.units}
                                    options={this.state.unitsOption}
                                    onChange={(name, value) => {
                                      this.setState({ units: value })
                                    }}
                                    disabled={
                                      this.state.categoryType === "view"
                                        ? true
                                        : false
                                    }
                                  />
                                  <label>Status</label>
                                  <Field
                                    className={"height-for-input-system"}
                                    inputType="checkbox"
                                    inputName="status"
                                    value={this.state.status}
                                    onChange={(name, value) => {
                                      this.setState({ status: value })
                                    }}
                                  />
                                </Fragment>
                              ) : this.state.categoryContentHeading ===
                                "CURRENCY" ? (
                                  <Fragment>
                                    <label>
                                      {this.state.categoryContentHeading
                                        .split("_")
                                        .join(" ")}{" "}
                                      Name
                              </label>
                                    <Async
                                      className={"height-for-input-system"}
                                      name="countryCode"
                                      value={this.state.currency}
                                      onChange={this.changeAsync}
                                      placeholder="Find Style"
                                      options={CountryServices.countryCode()}
                                      disabled={
                                        this.state.categoryType === "view"
                                          ? true
                                          : false
                                      }
                                    />

                                    <label>Value</label>
                                    <input
                                      type="number"
                                      class="form-control height-for-input-system"
                                      placeholder=""
                                      name="currencyValue"
                                      value={this.state.currencyValue}
                                      onChange={e =>
                                        this.setState({
                                          currencyValue: e.target.value
                                        })
                                      }
                                      disabled={
                                        this.state.categoryType === "view"
                                          ? true
                                          : false
                                      }
                                    />
                                  </Fragment>
                                ) : this.state.categoryContentHeading === "INITIAL" ||
                                  this.state.categoryContentHeading ===
                                  "PRODUCTION" ? (
                                    <Fragment>
                                      <label>
                                        {this.state.categoryContentHeading
                                          .split("_")
                                          .join(" ")}{" "}
                                        Name
                              </label>
                                      <Async
                                        className={"height-for-input-system"}
                                        name="doneBy"
                                        value={this.state.cadDoneBy}
                                        onInputChange={this.getDoneBy}
                                        onChange={this.changeCADDoneBy}
                                        options={this.state.doneBy}
                                        disabled={
                                          this.state.categoryType === "view"
                                            ? true
                                            : false
                                        }
                                      />
                                    </Fragment>
                                  ) : this.state.categoryContentHeading ===
                                    "PORT_OF_PICK_UP" ? (
                                      <Fragment>
                                        <label class="text-center">
                                          {this.state.categoryContentHeading
                                            .split("_")
                                            .join(" ")}
                                        </label>
                                        <Field
                                          className={"height-for-input-system"}
                                          isFormGroup={true}
                                          inputType="text"
                                          inputName="portofpickup"
                                          label={" Port of Pick up"}
                                          value={portOfPickup.portofpickup}
                                          onChange={this.updatePortOfPickup}
                                        />
                                        <Field
                                          className={"height-for-input-system"}
                                          isFormGroup={true}
                                          inputType="text"
                                          inputName="freightCostAbove500"
                                          value={portOfPickup.freightCostAbove500}
                                          label={"AIR FREIGHT COST ≥ 500 KGS"}
                                          onChange={this.updatePortOfPickup}
                                        />
                                        <Field
                                          className={"height-for-input-system"}
                                          isFormGroup={true}
                                          inputType="text"
                                          inputName="freightCostBelow500"
                                          value={portOfPickup.freightCostBelow500}
                                          label={"AIR FREIGHT COST < 500 KGS"}
                                          onChange={this.updatePortOfPickup}
                                        />
                                        <Field
                                          className={"height-for-input-system"}
                                          isFormGroup={true}
                                          inputType="text"
                                          inputName="seaFreightCost"
                                          value={portOfPickup.seaFreightCost}
                                          label={" Sea port"}
                                          onChange={this.updatePortOfPickup}
                                        />
                                      </Fragment>
                                    ) :
                                    this.state.categoryContentHeading ===
                                      "ASSIGNED_TO" ? (
                                        <Fragment>
                                          <label>
                                            {this.state.categoryContentHeading
                                              .split("_")
                                              .join(" ")}{" "}
                                            Name
                          </label>
                                          <div className="custom-async-select">
                                            <Async
                                              className={"height-for-input-system"}
                                              name="assignedTo"
                                              value={this.state.assignedToObj}
                                              // onInputChange = {this.searchEmploye}
                                              onChange={this.getAssignedTo}
                                              options={this.state.actionedByOption}
                                              disabled={
                                                this.state.categoryType === "view"
                                                  ? true
                                                  : false
                                              }
                                            />
                                          </div>
                                        </Fragment>
                                      )
                                      :
                                      this.state.categoryContentHeading ===
                                        "BACKING_TYPE" ? (
                                          <Fragment>
                                            <Field
                                              className={"height-for-input-system"}
                                              isFormGroup={true}
                                              inputType="text"
                                              inputName="categoryValue"
                                              value={this.state.categoryValue}
                                              label={`${this.state.categoryContentHeading.split("_").join(" ")} name`}
                                              onChange={(name, value) => this.setState({ [name]: value })}
                                              disabled={
                                                this.state.categoryType === "view"
                                                  ? true
                                                  : false
                                              }
                                            />
                                            <div class="col-md-12">
                                              {this.state.typeMultiple.map((mul, index) => {
                                                return <div class="dis-flex">
                                                  <div >
                                                    <Field
                                                      className={"height-for-input-system"}
                                                      isFormGroup={true}
                                                      inputType="number"
                                                      inputName="width"
                                                      value={mul.width}
                                                      label={`Width`}
                                                      index={index}
                                                      onChange={this.updateTypeMultiple}
                                                      disabled={
                                                        this.state.categoryType === "view"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                  </div>
                                                  <div class="ml-2">
                                                    <Field
                                                      className={"height-for-input-system"}
                                                      isFormGroup={true}
                                                      inputType="number"
                                                      inputName="price"
                                                      value={mul.price}
                                                      label={`Price`}
                                                      index={index}
                                                      onChange={this.updateTypeMultiple}
                                                      disabled={
                                                        this.state.categoryType === "view"
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                  </div>
                                                  {index === 0 ?
                                                    <Button
                                                      buttonType="add"
                                                      onClick={this.addTypeMultiple}
                                                    />
                                                    :
                                                    <Button
                                                      buttonType="remove"
                                                      onClick={(index) => this.removeMultiple(index)}
                                                    />
                                                  }
                                                </div>
                                              })}
                                            </div>

                                          </Fragment>
                                        )
                                        :
                                        this.state.categoryContentHeading ===
                                          "WASH_TYPE" || this.state.categoryContentHeading ===
                                          "EMB_FORM" ? (
                                            <Fragment>
                                              <Field
                                                className={"height-for-input-system"}
                                                isFormGroup={true}
                                                inputType="text"
                                                inputName="categoryValue"
                                                value={this.state.categoryValue}
                                                label={`${this.state.categoryContentHeading.split("_").join(" ")} name`}
                                                onChange={(name, value) => this.setState({ [name]: value })}
                                              />
                                              <div>
                                                <Field
                                                  className={"height-for-input-system"}
                                                  isFormGroup={true}
                                                  inputType="number"
                                                  inputName="price"
                                                  value={this.state.price}
                                                  label={`Price`}
                                                  onChange={(name, value) => this.setState({ [name]: value })}
                                                />
                                              </div>

                                            </Fragment>
                                          )
                                          : this.state.categoryContentHeading ===
                                            "TAILORS_NAME" ? (
                                              <Fragment>
                                                <Field
                                                  className={"height-for-input-system"}
                                                  isFormGroup={true}
                                                  inputType="text"
                                                  inputName="categoryValue"
                                                  value={this.state.categoryValue}
                                                  label={`${this.state.categoryContentHeading.split("_").join(" ")} name`}
                                                  onChange={(name, value) => this.setState({ [name]: value })}
                                                  disabled={
                                                    this.state.categoryType === "view"
                                                      ? true
                                                      : false
                                                  }
                                                />
                                                <div>
                                                  <Field
                                                    className={"height-for-input-system"}
                                                    isFormGroup={true}
                                                    inputType="text"
                                                    inputName="number"
                                                    value={this.state.number}
                                                    label={`Number`}
                                                    onChange={(name, value) => this.setState({ [name]: value })}
                                                    disabled={
                                                      this.state.categoryType === "view"
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                </div>

                                              </Fragment>
                                            )
                                            :
                                            (
                                              <Fragment>
                                                <label>
                                                  {this.state.categoryContentHeading !==
                                                    undefined &&
                                                    this.state.categoryContentHeading
                                                      .split("_")
                                                      .join(" ")}{" "}{["VALUE_LOSS", "DYING/PRINT", "UPCHARGE"].includes(this.state.categoryContentHeading)
                                                        ? "" // Do not append "Name" for these specific cases
                                                        : " Name"} {/* Append "Name" for other cases */}
                              </label>
                                                <input
                                                  // type={
                                                  //   this.state.categoryContentHeading
                                                  //     .split("_")
                                                  //     .join(" ") === "RATING" ||
                                                  //     this.state.categoryContentHeading
                                                  //       .split("_")
                                                  //       .join(" ") === "LOOPER" ||
                                                  //     this.state.categoryContentHeading
                                                  //       .split("_")
                                                  //       .join(" ") === "NEEDLE"
                                                  //     ? "number"
                                                  //     : "text"
                                                  // }
                                                  type={
                                                    ["DYING/PRINT", "VALUE_LOSS", "UPCHARGE", "RATING", "LOOPER", "NEEDLE"].includes(
                                                      this.state.categoryContentHeading
                                                    )
                                                      ? "number"
                                                      : "text"
                                                  }
                                                  class="form-control height-for-input-system"
                                                  placeholder=""
                                                  value={this.state.categoryValue}
                                                  onChange={e =>
                                                    this.setState({
                                                      categoryValue: e.target.value
                                                    })
                                                  }
                                                  disabled={
                                                    this.state.categoryType === "view"
                                                      ? true
                                                      : false
                                                  }
                                                />
                                              </Fragment>
                                            )}
                  </div>
                </div>
                <div class="col-md-12 profile-btn text-center">
                  {this.state.categoryType !== "view" && (
                    <button
                      type="button"
                      class="primary"
                      name="button"
                      onClick={e => {
                        this.submitValue(e);
                        setTimeout(() => {
                          window.history.back();
                        }, 1500)
                      }}
                    >
                      {this.state.categoryType === "add"
                        ? "Add"
                        : this.state.categoryType === "edit"
                          ? "Edit"
                          : this.state.categoryType === "view"
                            ? "View"
                            : ""}
                    </button>
                  )}
                  <a
                    onClick={() => window.history.back()}
                    class="primary ml-1"
                    style={{ cursor: "pointer", color: "white" }}
                  >
                    BACK
                        </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AddCategory;


// WEBPACK FOOTER //
// ./src/pages/systemAddCategory/page.js